import { BaseNode } from "./baseNode";

export const ConditionNode = ({ id }) => {
  return (
    <BaseNode
      id={id}
      title="Condition"
      leftHandles={[
        { id: `${id}-input`, top: '50%', label: 'Input' }
      ]}
      rightHandles={[
        { id: `${id}-true`, top: '35%', label: 'True' },
        { id: `${id}-false`, top: '65%', label: 'False' }
      ]}
    >
      <div>IF / ELSE Logic</div>
    </BaseNode>
  );
};
